/**
 * @generated SignedSource<<41d6fd97c8e27e1acfd88e52867c1c2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemInfo_Item_Query$variables = {
  id: string;
};
export type ItemInfo_Item_Query$data = {
  readonly item: {
    readonly __typename: "AnnouncementAttachment";
    readonly announcement: {
      readonly announcer: {
        readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
      };
      readonly id: string;
      readonly space: {
        readonly " $fragmentSpreads": FragmentRefs<"SpaceIndicator_space">;
      };
    };
  } | {
    readonly __typename: "FolderItem";
    readonly event: {
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"DateTimeLabel_event">;
    } | null;
    readonly folders: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
    };
    readonly space: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"SpaceIndicator_space">;
    };
  } | {
    readonly __typename: "MemberDetailsAttachment";
    readonly memberDetails: {
      readonly id: string;
      readonly member: {
        readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
      } | null;
    };
  } | {
    readonly __typename: "VaultItem";
    readonly vault: {
      readonly id: string;
      readonly name: string;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type ItemInfo_Item_Query = {
  response: ItemInfo_Item_Query$data;
  variables: ItemInfo_Item_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "SpaceIndicator_space"
},
v6 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v7 = {
  "alias": "folders",
  "args": null,
  "concreteType": "FolderConnection",
  "kind": "LinkedField",
  "name": "ownershipFolders",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Folder",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": (v6/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Vault",
      "kind": "LinkedField",
      "name": "vault",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    }
  ],
  "type": "VaultItem",
  "abstractKey": null
},
v9 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "UserHandle_member"
  }
],
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "time",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timestamp",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "utcDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "utcTime",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timezone",
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*: any*/)
      ],
      "type": "NamedIcon",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Color",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "light",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dark",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberAvatar",
    "kind": "LinkedField",
    "name": "avatar",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "roles",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ItemInfo_Item_Query",
    "selections": [
      {
        "alias": "item",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "event",
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "ownershipEvent",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DateTimeLabel_event"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "space",
                "args": null,
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "ownershipSpace",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "type": "FolderItem",
            "abstractKey": null
          },
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Announcement",
                "kind": "LinkedField",
                "name": "announcement",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "announcer",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AnnouncementAttachment",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberDetails",
                "kind": "LinkedField",
                "name": "memberDetails",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MemberDetailsAttachment",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ItemInfo_Item_Query",
    "selections": [
      {
        "alias": "item",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "event",
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "ownershipEvent",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DateTime",
                    "kind": "LinkedField",
                    "name": "start",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DateTime",
                    "kind": "LinkedField",
                    "name": "end",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allDay",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "space",
                "args": null,
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "ownershipSpace",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "type": "FolderItem",
            "abstractKey": null
          },
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Announcement",
                "kind": "LinkedField",
                "name": "announcement",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "announcer",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AnnouncementAttachment",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberDetails",
                "kind": "LinkedField",
                "name": "memberDetails",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MemberDetailsAttachment",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fc115f5e96a31ac107cf295b5422e8ff",
    "id": null,
    "metadata": {},
    "name": "ItemInfo_Item_Query",
    "operationKind": "query",
    "text": "query ItemInfo_Item_Query(\n  $id: ID!\n) {\n  item: node(id: $id) {\n    __typename\n    ... on FolderItem {\n      event: ownershipEvent {\n        id\n        name\n        ...DateTimeLabel_event\n      }\n      space: ownershipSpace {\n        name\n        ...SpaceIndicator_space\n        id\n      }\n      folders: ownershipFolders {\n        nodes {\n          id\n          name\n        }\n      }\n    }\n    ... on VaultItem {\n      vault {\n        id\n        name\n      }\n    }\n    ... on AnnouncementAttachment {\n      announcement {\n        id\n        announcer {\n          ...UserHandle_member\n          id\n        }\n        space {\n          ...SpaceIndicator_space\n          id\n        }\n      }\n    }\n    ... on MemberDetailsAttachment {\n      memberDetails {\n        id\n        member {\n          ...UserHandle_member\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment DateTimeLabel_event on Event {\n  id\n  start {\n    date\n    time\n    timestamp\n    utcDate\n    utcTime\n    timezone\n  }\n  end {\n    date\n    time\n    timestamp\n    utcDate\n    utcTime\n    timezone\n  }\n  allDay\n}\n\nfragment SpaceIndicator_space on Space {\n  id\n  name\n  icon {\n    __typename\n    ... on NamedIcon {\n      name\n    }\n  }\n  color {\n    light\n    dark\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n"
  }
};
})();

(node as any).hash = "6bb8cc84a3b4a12145d25bd4f772ab67";

export default node;
